export default __webpack_public_path__ + "static/img/image1.a89a8e9.png";